<div class="guts-p-h-2 m-guts-m-r-1">
  <div class="l_flex l_flex-justify-right guts-p-v-2 action-wrapper">
    <button
      [attr.aria-label]="'Core_Close' | translate"
      (click)="onCancel()"
      class="dg-modal__close-icon js-modal-close-btn l_flex-none"
      type="button"
      data-dgat="achievements-modal-637"
    >
      <df-icon icon="cross"></df-icon>
    </button>
  </div>

  <div
    *ngIf="achievement.contentType !== 'Badge'; else badgeImage"
    class="achievements-modal-header l_flex-middle m-l_flex-middle guts-p-b-2"
  >
    <df-icon
      icon="{{ achievement.contentType | lowercase }}"
      class="color-fuchsia zoom-icon"
      size="large"
    ></df-icon>
  </div>

  <ng-template #badgeImage>
    <div
      class="
        achievements-modal-header-badge
        l_flex-middle
        m-l_flex-middle
        guts-p-b-2
      "
    >
      <img
        class="achievements-modal-badge-image"
        src="{{ achievement.imageUrl }}"
        alt="{{ i18n.Core_Badge }}"
      />
    </div>
  </ng-template>

  <div class="left-text guts-p-v-2">
    <p class="par--small par--light">
      {{ titleTranslationMap[achievement.contentType] }}
    </p>
    <h2>{{ achievement.title | ellipsis: titleLimit }}</h2>
  </div>

  <!-- Accomplishment View -->
  <div *ngIf="achievement.contentType === 'Accomplishment'">
    <dgx-achievement-detail
      *ngIf="achievement.startDate && achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_StartDate"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_EndDate"
      [value]="achievement.endDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>

    <dgx-achievement-detail
      *ngIf="!achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_AchievedDate"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
  </div>

  <!-- Certificate View -->
  <div *ngIf="achievement.contentType === 'Certificate'">
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_IssuedBy"
      [value]="achievement.source | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_IssuerUrl"
      [value]="achievement.url | ellipsis: titleLimit"
      [href]="achievement.url"
      [isLink]="true"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgProfileOverview_CertificateNumber"
      [value]="achievement.certificateNumber?.toString() | ellipsis: titleLimit"
    ></dgx-achievement-detail>

    <dgx-achievement-detail
      *ngIf="achievement.startDate && achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_StartDate"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_EndDate"
      [value]="achievement.endDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>

    <dgx-achievement-detail
      *ngIf="!achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_AwardedDate"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>

    <dgx-achievement-detail
      *ngIf="hasImageUrl"
      [title]="i18n.dgProfileCollectionItem_CertImage"
      [isAttachment]="true"
      [value]="i18n.dgProfileOverview_ViewCertificate"
      [click]="viewAttachment"
    ></dgx-achievement-detail>
  </div>

  <!-- Award View -->
  <div *ngIf="achievement.contentType === 'Award'">
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_IssuedBy"
      [value]="achievement.source | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_IssuerUrl"
      [value]="achievement.url | ellipsis: titleLimit"
      [href]="achievement.url"
      [isLink]="true"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgProfileOverview_AwardReceivedDate"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      *ngIf="hasImageUrl"
      [title]="i18n.dgProfileCollectionItem_CertImage"
      [isAttachment]="true"
      [value]="i18n.dgProfileOverview_ViewAward"
      [click]="viewAttachment"
    ></dgx-achievement-detail>
  </div>

  <!-- Degree View -->
  <div *ngIf="achievement.contentType === 'Degree'">
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_Country"
      [value]="achievement.country | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_CollegeUniversity"
      [value]="achievement.source | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_DegreeLevel"
      [value]="achievement.levelText | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_GPA"
      [value]="achievement.gpa | ellipsis: titleLimit"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_DateCompleted"
      [value]="achievement.endDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      *ngIf="hasImageUrl"
      [title]="i18n.dgProfileCollectionItem_CertImage"
      [isAttachment]="true"
      [value]="i18n.dgProfileOverview_ViewDegree"
      [click]="viewAttachment"
    ></dgx-achievement-detail>
  </div>

  <!-- Badge View -->
  <div *ngIf="achievement.contentType === 'Badge'">
    <dgx-achievement-detail
      *ngIf="hasImageUrl"
      [title]="i18n.Core_Image"
      [isAttachment]="true"
      [value]="i18n.dgProfileOverview_ViewBadge"
      [click]="viewAttachment"
    >
    </dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.dgUserOutcomeEditForm_IssuerUrl"
      [value]="achievement.url | ellipsis: 30"
      [href]="achievement.url"
      [isLink]="true"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      [title]="i18n.Cred_Certificate_DateIssued"
      [value]="achievement.startDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      *ngIf="achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_Expiration"
      [value]="achievement.endDate | date: 'MMMM yyyy'"
    ></dgx-achievement-detail>
    <dgx-achievement-detail
      *ngIf="!achievement.endDate"
      [title]="i18n.dgUserOutcomeEditForm_Expiration"
      [value]="i18n.dgProfileOverview_OverviewNotProvidedTitle"
    ></dgx-achievement-detail>
  </div>

  <!-- Skills -->
  <div class="guts-p-v-2">
    <span
      *ngFor="let skill of displayedSkillNames"
      class="
        btn btn-sm
        bg-ebony-a08
        color-ebony
        guts-m-v-quart guts-m-r-half guts-p-r-half
      "
      data-dgat="achievements-modal-b3a"
    >
      {{ skill }}
    </span>
    <span
      *ngIf="extraSkillCount > 0"
      class="
        btn btn-sm
        bg-ebony-a08
        color-ebony
        guts-m-v-quart guts-m-r-half guts-p-r-half
      "
      >+{{ extraSkillCount }}</span
    >
  </div>

  <hr class="footer-hr" />

  <!-- Menu -->
  <div class="action-wrapper guts-p-v-2">
    <dgx-user-outcome-actions
      [item]="achievementItem"
      [contentType]="achievement.contentType"
      [itemId]="achievement.userOutcomeId"
      [appendToBody]="false"
      (onModalMenu)="onModalMenu()"
    ></dgx-user-outcome-actions>
  </div>
</div>
